/**
 * @returns {string} value stored
 */
const get = (key) => () => {
	try {
		return JSON.parse(localStorage.getItem(key))
	} catch (error) {
		return null
	}
}

/**
 * @param {string} key key of the item to be stored
 * @param value value to be stored
 * @returns {void}
 */
const set = (key) => (value) => localStorage.setItem(key, JSON.stringify(value))

/**
 * @param {string} key Key of the item to be removed
 */
const remove = (key) => () => localStorage.removeItem(key)

const KEYS = {
	user: 'authentication/user',
	accessToken: 'authentication/accessToken',
	refreshToken: 'authentication/refreshToken',
	inviteHash: 'friend-invite/hash',
	lastOrigin: 'lastOrigin',
	lastDestination: 'lastDestination',
	userSessionId: 'userSessionId',
	cart: 'ticket-sale/cart',
}

export class StorageService {
	/**
	 * Exposes authentication related storage operations
	 */
	static authentication = {
		/**
		 * Get or set an user
		 */
		user: {
			/**
			 * Get the current user
			 */
			get: get(KEYS.user),
			/**
			 * Set the current user
			 */
			set: set(KEYS.user),
			/**
			 * Remove the current user
			 */
			remove: remove(KEYS.user),
		},
	}

	/**
	 * Get from or set an invite hash
	 */
	static inviteHash = {
		/**
		 * Get the invite hash
		 */
		get: get(KEYS.inviteHash),
		/**
		 * Set the invite hash
		 */
		set: set(KEYS.inviteHash),
		/**
		 * Remove the invite hash
		 */
		remove: remove(KEYS.inviteHash),
	}

	/**
	 * Get from or set a trip last origin
	 */
	static lastOrigin = {
		/**
		 * Get the invite hash
		 */
		get: get(KEYS.lastOrigin),
		/**
		 * Set the invite hash
		 */
		set: set(KEYS.lastOrigin),
		/**
		 * Remove the invite hash
		 */
		remove: remove(KEYS.lastOrigin),
	}

	/**
	 * Get from or set a trip last destination
	 */
	static lastDestination = {
		/**
		 * Get the invite hash
		 */
		get: get(KEYS.lastDestination),
		/**
		 * Set the invite hash
		 */
		set: set(KEYS.lastDestination),
		/**
		 * Remove the invite hash
		 */
		remove: remove(KEYS.lastDestination),
	}

	/**
	 * Get from or set a trip last destination
	 */
	static useSessionId = {
		/**
		 * Get the invite hash
		 */
		get: get(KEYS.userSessionId),
		/**
		 * Set the invite hash
		 */
		set: set(KEYS.userSessionId),
		/**
		 * Remove the invite hash
		 */
		remove: remove(KEYS.userSessionId),
	}

	/**
	 * Get from or set the shopping cart created for the current ticket sale
	 */
	static cart = {
		/**
		 * Get the shopping cart
		 */
		get: get(KEYS.cart),
		/**
		 * Set the shopping cart
		 */
		set: set(KEYS.cart),
		/**
		 * Remove the shopping cart
		 */
		remove: remove(KEYS.cart),
	}
}
